import Api from '@/api'

export default {
  signIn(params) {
    return Api.request({
      url: 'user/signin',
      data: params
    });
  },

  verifyOTP(params) {
    return Api.request({
      url: 'user/signin/verify',
      data: params
    });
  },

  signOut(params) {
    return Api.request({
      url: 'user/signout',
      data: params
    });
  },

  get(userId) {
    return Api.request({
      url: `user/${userId}`
    });
  },

  update(user) {
    return Api.request({
      url: `user/${user.userId}`,
      data: user
    });
  },

  filterOrders(params) {
    return Api.request({
      url: `user/order/filter`,
      data: params
    });
  }
}
